import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { TemplateChips } from '@/components/ui/template-chips';
import { ADMIN_REJECT_APPEAL_TEMPLATES } from '../data/admin-appeal-templates';

export const ADMIN_NOTE_MAX = 500;

export function NoteTextarea(p: {
  value: string;
  onChange: (v: string) => void;
}): ReactNode {
  return (
    <textarea
      value={p.value}
      onChange={(e) => p.onChange(e.target.value.slice(0, ADMIN_NOTE_MAX))}
      placeholder="Escribe un motivo personalizado o elige uno arriba"
      rows={3}
      className="w-full rounded-md border border-white/[0.06] bg-surface-elevated p-sm text-xs text-text-primary placeholder:text-text-tertiary focus:border-brand-red focus:outline-none"
    />
  );
}

export function RejectChips(p: {
  current: string;
  onPick: (v: string) => void;
}): ReactNode {
  return (
    <TemplateChips
      templates={ADMIN_REJECT_APPEAL_TEMPLATES}
      current={p.current}
      onPick={p.onPick}
    />
  );
}

export function HelpLine(): ReactNode {
  return (
    <p className="text-xs text-text-secondary">
      Motivo opcional para el collector (lo verá en su detalle):
    </p>
  );
}

function CancelBtn(p: { onClick: () => void; disabled: boolean }): ReactNode {
  return (
    <Button variant="ghost" size="sm" onClick={p.onClick} disabled={p.disabled}>
      Cancelar
    </Button>
  );
}

function ConfirmBtn(p: { onClick: () => void; disabled: boolean }): ReactNode {
  return (
    <Button
      variant="primary"
      size="sm"
      onClick={p.onClick}
      disabled={p.disabled}
    >
      Confirmar rechazo
    </Button>
  );
}

type FooterProps = {
  noteLength: number;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function FormFooter(p: FooterProps): ReactNode {
  return (
    <div className="flex items-center justify-between gap-sm">
      <span className="text-xs text-text-tertiary">
        {p.noteLength}/{ADMIN_NOTE_MAX}
      </span>
      <div className="flex items-center gap-sm">
        <CancelBtn onClick={p.onCancel} disabled={p.isPending} />
        <ConfirmBtn onClick={p.onConfirm} disabled={p.isPending} />
      </div>
    </div>
  );
}
